import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ClaveClienteFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
    return (
        <Form.Group>
            <Form.Label text='Clave Cliente' htmlFor='input-claveCLienteSIRE' md={4} alignRightAt='md' />
            <Col md={8}>
                <Field name='claveCLienteSIRE'>
                    {({ field }) => (
                        <Form.InputText
                            {...field}
                            type='password'
                            isInvalid={iTouched && iError}
                            disabled={fIsSubmitting}
                            id='input-claveCLienteSIRE'
                        />
                    )}
                </Field>
                {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
            </Col>
        </Form.Group>
    )
}

export default React.memo(ClaveClienteFormGroup)
